import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Breadcrumb, { Crumb } from "src/components/Breadcrumb";
import NavItemSignout from "src/components/layout/LayoutStudent/NavItem/NavItemSignout";
import NavItems from "src/components/layout/LayoutStudent/NavItems";
import ToggleButton from "src/components/layout/ToggleButton";
import UserProfileButton from "src/components/layout/UserProfileButton";
import Link from "src/components/Link";
import useAuth from "src/hooks/selectors/useAuth";
import useElementSize from "src/hooks/useElementSize";
import useWindowSize from "src/hooks/useWindowSize";
import Container from "src/components/layout/Container";
import LanguageSelector from "src/components/language/LanguageSelector";
import Logo from "src/components/Logo";

interface LayoutHeadProps {
	title?: string;
	actions?: any;
	breadcrumb?: Crumb[];
}

const LayoutHead = ({ title, breadcrumb }: LayoutHeadProps) => {
	const [visible, setVisible] = useState(false);
	const { ref, size } = useElementSize();
	const location = useLocation();
	const auth = useAuth();
	const { isPhone, isTablet } = useWindowSize();
	useEffect(() => {
		setVisible(false);
	}, [location]);

	const renderLogo = () => {
		return (
			<div className="flex z-20 items-center gap-[12px]">
				<Link
					to="/dashboard"
					className={
						"flex items-center md:p-3 rounded-md bg-white md:bg-dark dark:bg-dark-accent justify-center"
					}
				>
					<Logo
						color={isPhone || isTablet ? "primary" : "white"}
						variant="small"
						className="w-[36px] p-2 md:p-0 md:w-8"
					/>
				</Link>
				{!isPhone && (
					<>
						{typeof title === "string" && (
							<h2 className="text-white text-[18px] lg:text-[28px]">
								{title}
							</h2>
						)}
						{typeof title !== "string" && (
							<div className="flex flex-1 items-center gap-[12px]">
								{title}
							</div>
						)}
					</>
				)}
			</div>
		);
	};

	return (
		<>
			<motion.div
				initial={false}
				animate={visible ? "open" : "closed"}
				{...{ ref }}
				className={`flex bg-dark py-2 lg:py-4 mb-8 z-[90] sticky top-0`}
			>
				<Container
					variant="xlarge"
					className="flex flex-1 justify-between items-center gap-4"
				>
					{renderLogo()}
					<div className="flex items-center flex-1 text-white z-20 bg-dark gap-4 justify-between">
						<div className="flex flex-1 items-center">
							{breadcrumb && (
								<div className="hidden lg:flex">
									<Breadcrumb routes={breadcrumb} />
								</div>
							)}
						</div>
						<div className="flex lg items-center gap-4">
							<LanguageSelector
								theme="light"
								position="bottom-right"
							/>
							<UserProfileButton />
							<div className="flex lg:hidden">
								<ToggleButton
									onClick={() => setVisible(!visible)}
								/>
							</div>
						</div>
					</div>
				</Container>
			</motion.div>
			<AnimatePresence>
				{visible && (
					<motion.div
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}
						className="fixed inset-0 bg-white z-[80] flex flex-col flex-1"
						style={{
							paddingTop: size.top + size.height,
						}}
					>
						<div className="container py-8 flex-col flex-1">
							<div className="flex flex-col flex-1">
								<NavItems />
							</div>
							<NavItemSignout
								className={`gtm-${auth.type}-dashboard-sidebar--link-logout`}
							></NavItemSignout>
						</div>
					</motion.div>
				)}
			</AnimatePresence>
		</>
	);
};

export default LayoutHead;
